import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { PoButtonModule } from '@po-ui/ng-components';

@Component({
  standalone: true,
  selector: 'app-access-denied',
  imports: [PoButtonModule],
  templateUrl: './access-denied.component.html',
  styleUrl: './access-denied.component.css'
})
export class AccessDeniedComponent {
  constructor(private router: Router) {}

  goHome(): void {
    this.router.navigate(['/home']);
  }

  openDocumentation(): void {
    window.open('https://tdn.totvs.com/x/_3-RNw', '_blank');
  }
}
